import { render } from "./WatchSec.vue?vue&type=template&id=4a2fc7ec&scoped=true"
import script from "./WatchSec.vue?vue&type=script&lang=js"
export * from "./WatchSec.vue?vue&type=script&lang=js"

import "./WatchSec.vue?vue&type=style&index=0&id=4a2fc7ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2fc7ec"]])

export default __exports__